// extracted by mini-css-extract-plugin
module.exports = {"group":"style_group__1WdL4","input":"style_input__1yg5y"};